import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { TEACHERS_BULK_UPLOAD_WORK_UPLOAD_AND_QR_URL } from 'config/urls';

import { ReactComponent as AddIcon } from 'pages/Teachers/Home/assets/add-icon.svg';
import { ReactComponent as DocumentIcon } from 'pages/Teachers/Home/assets/document-icon.svg';
import { reverse } from 'utils/urls';

import AssignmentDialogContext from 'components/AssignmentDialogContext';

import styles from './styles.module.scss';

const DashboardHeader = () => {
  const history = useHistory();
  const { setIsAssignmentDialogOpened } = useContext(AssignmentDialogContext);

  return (
    <header className={styles.header}>
      <div className={styles.headerActions}>
        <button
          className={styles.iconBtn}
          onClick={() => {
            history.push({
              pathname: reverse(TEACHERS_BULK_UPLOAD_WORK_UPLOAD_AND_QR_URL)
            });
          }}
        >
          <DocumentIcon />
        </button>
        <button
          onClick={() => {
            setIsAssignmentDialogOpened(true);
          }}
          className={styles.createBtn}
        >
          <span className={styles.addIconWrapper}>
            <AddIcon />
          </span>
          <span>Create Assignment</span>
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
